<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="offer-transformed-hint" *ngIf="issueControl.value">

            Dieses Angebot wurde bereits einem Vorgang zugeordnet. <span class="link" (click)="showIssue()">Anzeigen</span>

        </div>

        <div class="content-row-2">

            <div class="section-wrapper" formGroupName="offer">

                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">euro_symbol</mat-icon>
        
                    <span class="text">
                        Kopfdaten
                    </span>
        
                    <span class="spacer"></span>
        
                </div>
    
                <div class="header">
    
                    <div class="title-wrapper">
    
                        <div class="main-input-wrapper">
                            <mat-form-field class="width main-input" appearance="outline">
                                <div matPrefix class="number-prefix">{{numberControl.value? numberControl.value: 'neu'}}</div>
                                <mat-label>Titel</mat-label>
                                <input formControlName="offertitle" matInput />
                                <button mat-icon-button @fade matSuffix color="warn" [disabled]="disabled || !titleControl.value" (click)="clearTitle()">
                                    <mat-icon>clear</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
    
                        <app-concurrency-label [entityIsSupported]="false"></app-concurrency-label>
    
                    </div>
        
                    <div class="header-data-wrapper">
    
                        <app-select-status-form class="limited-width" [appearance]="appearance" formControlName="offerstate"></app-select-status-form>
                        <app-select-customer [appearance]="appearance" formControlName="offercustomer"></app-select-customer>
                        <app-select-contact [appearance]="appearance" [customerSetted]="customerControl.value" formControlName="localcontact" label="Ansprechpartner vor Ort"></app-select-contact>
                        <app-select-contact [appearance]="appearance" [customerSetted]="customerControl.value" formControlName="commercialcontact" label="Geschäftlicher Ansprechpartner"></app-select-contact>

                    </div>
        
                </div>
            </div>
    
            <div class="section-wrapper" formGroupName="offer">

                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">edit</mat-icon>
        
                    <span class="text">
                        Beschreibung
                    </span>
        
                    <span class="spacer"></span>
        
                </div>
    
                <div class="description-wrapper quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">
        
                    <quill-editor *ngIf="!disabled" formControlName="offerdesc" [format]="'html'" class="quill-note" [modules]="modules"></quill-editor>
                    <quill-view *ngIf="disabled" [content]="descriptionControl.value" [format]="'html'" class="quill-note"></quill-view>
    
                </div>
    
            </div>

        </div>

        <div class="content-row-2">

            <div class="section-wrapper">

                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">location_on</mat-icon>
        
                    <span class="text">
                        Rechnungsaddresse
                    </span>
        
                    <span class="spacer"></span>
        
                    <button [disabled]="billingAddressControl.invalid" mat-icon-button matTooltip="Adresse auf Karte anzeigen" (click)="showBillingAddress()">
                        <mat-icon>map</mat-icon>
                    </button>

                </div>

                <div class="address-wrapper" formGroupName="billingaddress">

                    <app-address-form></app-address-form>

                </div>

            </div>

            <div class="section-wrapper">

                <div class="section-headline optional">
    
                    <mat-icon class="main-icon">engineering</mat-icon>
        
                    <span class="text">
                        Serviceadresse
                    </span>
        
                    <span class="spacer"></span>

                    <button [disabled]="serviceAddressControl.invalid" mat-icon-button matTooltip="Adresse auf Karte anzeigen" (click)="showServiceAddress()">
                        <mat-icon>map</mat-icon>
                    </button>
        
                </div>

                <div class="address-wrapper" formGroupName="serviceaddress">

                    <app-address-form></app-address-form>

                </div>

            </div>

        </div>

        <div class="section-wrapper">

            <div class="section-headline optional">
    
                <mat-icon class="main-icon">router</mat-icon>
    
                <span class="text">
                    Angebotsartikel
                </span>
    
                <span class="spacer"></span>

                <div class="controls" *ngIf="!disabled">
    
                    <div *ngIf="formGroup.enabled" class="control-button" (click)="addArticle()" matTooltip="Neuen Artikel anlegen">
                        <mat-icon>add</mat-icon>
                    </div>

                    <div *ngIf="formGroup.enabled" class="control-button" (click)="openItemAssist()" matTooltip="AMS Artikelassistent">
                        <mat-icon>adb</mat-icon>
                    </div>
    
                </div>
    
            </div>

            <div class="offer-items-wrapper">
                <app-offer-items-form2 [disabled]="disabled" [showFooter]="false" [columns]="itemColumns"></app-offer-items-form2>
            </div>

        </div>

        <div class="section-wrapper" formGroupName="offer">

            <div class="section-headline optional">
    
                <mat-icon class="main-icon">menu</mat-icon>
    
                <span class="text">
                    Angebotstext
                </span>
    
                <span class="spacer"></span>
    
            </div>

            <div class="offer-text-wrapper">
                <app-a4-page-text-editor [editable]="!disabled" formControlName="customoffernote"></app-a4-page-text-editor>
            </div>

        </div>

    </div>

</div>
